module.exports = __webpack_public_path__ + "img/sombraylineas4.5bc9614c.png";